import React from 'react'

const ActionButton = ({T, icon, title, onClick}) => {
    return (
        <div className="actionButton" onClick={onClick}>
            {icon}&nbsp; {T(title)}
        </div>
    )
}

export default ActionButton
